import { render } from "./ProgramarClasesView.vue?vue&type=template&id=502e226a&scoped=true"
import script from "./ProgramarClasesView.vue?vue&type=script&lang=js"
export * from "./ProgramarClasesView.vue?vue&type=script&lang=js"

import "./ProgramarClasesView.vue?vue&type=style&index=0&id=502e226a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502e226a"]])

export default __exports__